/* ============================================================
   NORTHSHEEP — Smart cart upsells (TEST feature)
   - Ranks the server-rendered candidate cards client-side:
     below the free-shipping threshold, products whose price is >=
     the remaining amount come first (closest above), then the rest
     (closest below). Shows the top N (max setting) per surface.
   - Quick-adds the first available variant via the Shopify cart AJAX
     API, then refreshes Dawn's cart drawer / cart page sections so the
     totals, free-shipping bar and upsell block all update. Drawer
     stays open. Multi-variant products use a "View" link instead.
   ============================================================ */
(function () {
  if (window.__nsCartUpsellLoaded) return;
  window.__nsCartUpsellLoaded = true;

  var observer = null;

  function rankBlock(block) {
    var row = block.querySelector('[data-ns-cu-row]');
    if (!row) return;
    var cards = Array.prototype.slice.call(row.children).filter(function (c) {
      return c.nodeType === 1 && c.hasAttribute('data-ns-cu-card');
    });
    if (!cards.length) return;
    var below = block.getAttribute('data-below') === '1';
    var remaining = parseInt(block.getAttribute('data-remaining'), 10) || 0;
    var max = parseInt(block.getAttribute('data-max'), 10) || 3;

    if (below && remaining > 0 && cards.length > 1) {
      var sorted = cards.slice().sort(function (a, b) {
        var pa = parseInt(a.getAttribute('data-price'), 10) || 0;
        var pb = parseInt(b.getAttribute('data-price'), 10) || 0;
        var aAbove = pa >= remaining;
        var bAbove = pb >= remaining;
        if (aAbove && bAbove) return pa - pb; // both qualify -> cheapest (closest above) first
        if (!aAbove && !bAbove) return pb - pa; // neither qualifies -> dearest (closest below) first
        return aAbove ? -1 : 1; // qualifying products first
      });
      /* ONLY MOVE CARDS WHEN THE ORDER ACTUALLY CHANGES. Re-appending a node
         that is already in place still removes and re-inserts it: its :hover
         is dropped and the card's image zoom restarts. Other scripts touch the
         cart markup (card cart-state labels, swatches), each touch re-ran
         this ranking, and on the cart page's full product cards that showed
         as the image zooming in and out while hovered. */
      var changed = sorted.some(function (c, i) {
        return c !== cards[i];
      });
      if (changed) {
        sorted.forEach(function (c) {
          row.appendChild(c);
        });
      }
      cards = sorted;
    }
    cards.forEach(function (c, i) {
      var want = i < max ? '' : 'none';
      if (c.style.display !== want) c.style.display = want;
    });
  }

  function rankAll() {
    if (observer) observer.disconnect();
    var blocks = document.querySelectorAll('[data-ns-cart-upsell]');
    for (var i = 0; i < blocks.length; i++) rankBlock(blocks[i]);
    syncAllBars();
    reconnect();
  }

  // ---- Position bar under the strip (new cart design) ---------------------
  /* The strip's own scrollbar is hidden in the new design, and a phone never
     shows one until the row is already moving — so without this nothing said
     "there is more to the right". The bar mirrors the row: thumb width is the
     visible share, thumb position the scroll position. Drag or click it to
     move the row. Everything is looked up from the event, never held, because
     the drawer's markup is replaced on every cart change. */
  function barFor(row) {
    var block = row.closest('[data-ns-cart-upsell]');
    return block ? block.querySelector('[data-ns-cu-bar]') : null;
  }

  function syncBar(row) {
    var max = row.scrollWidth - row.clientWidth;
    // The grab cursor for mouse dragging (below) shows only when there is
    // somewhere to go.
    row.classList.toggle('is-scrollable', max > 2);
    var bar = barFor(row);
    if (!bar) return;
    // Nothing to scroll (everything fits).
    if (max <= 2) {
      bar.hidden = true;
      return;
    }
    bar.hidden = false;
    var thumb = bar.firstElementChild;
    var trackW = bar.clientWidth;
    if (!thumb || !trackW) return;
    var thumbW = Math.max(36, Math.round(trackW * (row.clientWidth / row.scrollWidth)));
    var x = (trackW - thumbW) * Math.min(1, Math.max(0, row.scrollLeft / max));
    thumb.style.width = thumbW + 'px';
    thumb.style.transform = 'translateX(' + x.toFixed(1) + 'px)';
  }

  function syncAllBars() {
    var rows = document.querySelectorAll('[data-ns-cu-row]');
    for (var i = 0; i < rows.length; i++) syncBar(rows[i]);
  }

  // scroll does not bubble, but it can be captured on the document. Browsers
  // already fire scroll at most once per frame, so no extra throttling.
  document.addEventListener(
    'scroll',
    function (e) {
      var row = e.target;
      if (row && row.matches && row.matches('[data-ns-cu-row]')) syncBar(row);
    },
    { capture: true, passive: true }
  );
  window.addEventListener('resize', function () {
    window.clearTimeout(syncAllBars._t);
    syncAllBars._t = window.setTimeout(syncAllBars, 120);
  });
  // The drawer is laid out while closed, but fonts arriving change widths.
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncAllBars);

  document.addEventListener('pointerdown', function (e) {
    var bar = e.target.closest && e.target.closest('[data-ns-cu-bar]');
    if (!bar || e.button > 0) return;
    var block = bar.closest('[data-ns-cart-upsell]');
    var row = block && block.querySelector('[data-ns-cu-row]');
    var thumb = bar.firstElementChild;
    if (!row || !thumb) return;
    e.preventDefault();

    var rect = bar.getBoundingClientRect();
    var thumbW = thumb.offsetWidth;
    // Grabbing the thumb keeps it under the finger where it was taken; a
    // press on the track centres the thumb on the press.
    var grab = e.target === thumb ? e.clientX - thumb.getBoundingClientRect().left : thumbW / 2;
    var span = rect.width - thumbW;

    function moveTo(clientX) {
      if (span <= 0) return;
      var p = Math.min(1, Math.max(0, (clientX - rect.left - grab) / span));
      row.scrollLeft = p * (row.scrollWidth - row.clientWidth);
    }
    function onMove(ev) {
      moveTo(ev.clientX);
    }
    function onUp() {
      bar.classList.remove('is-dragging');
      bar.removeEventListener('pointermove', onMove);
      bar.removeEventListener('pointerup', onUp);
      bar.removeEventListener('pointercancel', onUp);
    }

    bar.addEventListener('pointermove', onMove);
    bar.addEventListener('pointerup', onUp);
    bar.addEventListener('pointercancel', onUp);
    bar.classList.add('is-dragging');
    moveTo(e.clientX);
    // Keeps the drag going when the pointer leaves the thin bar. Can throw
    // for a pointer the browser no longer tracks; the drag works without it.
    try {
      if (bar.setPointerCapture) bar.setPointerCapture(e.pointerId);
    } catch (err) {}
  });

  /* Mouse browsing of the suggestion row, on the basket page and in the
     drawer (owner, 2026-09-15) — the same two gestures as the colour pills on
     a collection page: (1) click-and-drag scrolls the row, and (2) resting
     the pointer near either end glides it that way, faster the closer to the
     edge. Mouse only — touch keeps its native swipe. A drag of more than 5px
     swallows the click that follows, so letting go over "Add to basket" adds
     nothing; that listener sits on WINDOW in the capture phase, ahead of the
     add handler on document. The glide stops at the end of the row and is
     skipped for prefers-reduced-motion (dragging still works). Everything is
     looked up from the event, never held: the drawer is re-rendered on every
     cart change. */
  var CU_EDGE = 90, CU_EDGE_MAX = 8;
  var cuDrag = null, cuSwallowClick = false, cuEdge = { row: null, v: 0, raf: 0 };
  function cuRowOf(t) { return t && t.closest ? t.closest('[data-ns-cu-row]') : null; }
  function cuOverflows(row) { return row.scrollWidth - row.clientWidth > 2; }
  function stopCuEdge() { cuEdge.v = 0; if (cuEdge.raf) cancelAnimationFrame(cuEdge.raf); cuEdge.raf = 0; }
  function cuEdgeStep() {
    var e = cuEdge;
    if (!e.row || !e.v || !e.row.isConnected) { e.raf = 0; return; }
    var before = e.row.scrollLeft;
    e.row.scrollLeft += e.v;
    if (e.row.scrollLeft === before) { e.raf = 0; return; } // reached the end
    e.raf = requestAnimationFrame(cuEdgeStep);
  }
  document.addEventListener('pointerdown', function (e) {
    cuSwallowClick = false;
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var row = cuRowOf(e.target);
    if (!row || !cuOverflows(row)) return;
    stopCuEdge();
    cuDrag = { row: row, x: e.clientX, left: row.scrollLeft, moved: false, id: e.pointerId };
  });
  document.addEventListener('pointermove', function (e) {
    if (e.pointerType !== 'mouse') return;
    if (cuDrag) {
      var dx = e.clientX - cuDrag.x;
      if (!cuDrag.moved && Math.abs(dx) > 5) {
        cuDrag.moved = true;
        cuDrag.row.classList.add('is-dragging');
        try { cuDrag.row.setPointerCapture(cuDrag.id); } catch (err) {}
      }
      if (cuDrag.moved) cuDrag.row.scrollLeft = cuDrag.left - dx;
      return;
    }
    var row = cuRowOf(e.target);
    if (!row || !cuOverflows(row) || matchMedia('(prefers-reduced-motion: reduce)').matches) { stopCuEdge(); return; }
    var r = row.getBoundingClientRect(), v = 0;
    if (e.clientX > r.right - CU_EDGE) v = Math.ceil(CU_EDGE_MAX * (e.clientX - (r.right - CU_EDGE)) / CU_EDGE);
    else if (e.clientX < r.left + CU_EDGE) v = -Math.ceil(CU_EDGE_MAX * ((r.left + CU_EDGE) - e.clientX) / CU_EDGE);
    cuEdge.row = row;
    cuEdge.v = v;
    if (!v) stopCuEdge();
    else if (!cuEdge.raf) cuEdge.raf = requestAnimationFrame(cuEdgeStep);
  }, { passive: true });
  function endCuDrag() {
    if (!cuDrag) return;
    if (cuDrag.moved) { cuSwallowClick = true; cuDrag.row.classList.remove('is-dragging'); }
    cuDrag = null;
  }
  document.addEventListener('pointerup', endCuDrag);
  document.addEventListener('pointercancel', endCuDrag);
  document.addEventListener('pointerout', function (e) {
    if (e.pointerType === 'mouse' && cuRowOf(e.target) && !cuRowOf(e.relatedTarget)) stopCuEdge();
  }, { passive: true });
  window.addEventListener('click', function (e) {
    if (!cuSwallowClick) return;
    cuSwallowClick = false;
    if (cuRowOf(e.target)) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  document.addEventListener('dragstart', function (e) { if (cuRowOf(e.target)) e.preventDefault(); });

  function reconnect() {
    if (!observer) return;
    ['cart-drawer', '#main-cart-items', '#main-cart-footer'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) observer.observe(el, { childList: true, subtree: true });
    });
  }

  // ---- AJAX quick-add -----------------------------------------------------
  function getSectionInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  /* The cart page's two sections, by their REAL section ids.

     These used to be requested by file name ('main-cart-items',
     'main-cart-footer'). The Section Rendering API accepts that, but renders
     the file standalone — without the blocks and settings the cart template
     gives it. The items section has no blocks, so it came back right; the
     footer's subtotal lives in a block, so it came back empty and was never
     replaced: after adding a suggestion on /cart the total and the
     free-shipping line stayed stale until a reload. Dawn's own cart.js reads
     the id from data-id for exactly this reason. */
  function cartPageSections() {
    return ['main-cart-items', 'main-cart-footer']
      .map(function (elId) {
        var el = document.getElementById(elId);
        return el && el.dataset.id ? { elId: elId, sectionId: el.dataset.id } : null;
      })
      .filter(Boolean);
  }

  function updateCartPage(response) {
    if (!response.sections) return;
    cartPageSections().forEach(function (s) {
      var dest = document.getElementById(s.elId);
      var html = response.sections[s.sectionId];
      if (!dest || !html) return;
      var destInner = dest.querySelector('.js-contents');
      var inner = getSectionInnerHTML(html, '.js-contents');
      if (destInner && inner != null) destInner.innerHTML = inner;
    });
    var bubbleHtml = response.sections['cart-icon-bubble'];
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && bubbleHtml) {
      var inner = getSectionInnerHTML(bubbleHtml, '.shopify-section') || bubbleHtml;
      bubble.innerHTML = inner;
    }
  }

  /* On /cart the header's cart icon still opens the drawer, so the page and
     the drawer show the same basket twice — and each only ever refreshed
     itself. Change the basket on the page, open the drawer: old contents.
     Change it in the drawer, close it: old page. These keep the other copy in
     step, without opening anything or moving focus. */
  function updateDrawerQuietly(sections) {
    var html = sections && sections['cart-drawer'];
    var host = document.getElementById('CartDrawer');
    if (!html || !host) return;
    var inner = getSectionInnerHTML(html, '#CartDrawer');
    if (inner == null) return;
    host.innerHTML = inner;
    var drawer = host.closest('cart-drawer');
    if (!drawer) return;
    drawer.classList.toggle('is-empty', !host.querySelector('.cart-item'));
    // Dawn binds the overlay's click-to-close once; the new overlay needs it too.
    var overlay = host.querySelector('#CartDrawer-Overlay');
    if (overlay && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
  }

  // No JSON Accept header: on /cart that asks for the cart API (the cart
  // object) instead of the rendered sections. The sections come back as JSON
  // anyway. Rendered at /cart itself, so the cart template's section ids
  // resolve.
  function fetchSections(ids) {
    return fetch(window.location.pathname + '?sections=' + ids.join(',')).then(function (r) {
      return r.json();
    });
  }

  function syncOtherCartCopy() {
    if (!document.getElementById('main-cart-items') || !document.getElementById('CartDrawer')) return;
    var drawerOpen = !!document.querySelector('cart-drawer.active');
    var pageIds = cartPageSections().map(function (s) {
      return s.sectionId;
    });
    // Drawer open: the change was made in it, so the page is the stale copy.
    var ids = drawerOpen ? pageIds : ['cart-drawer'];
    if (!ids.length) return;
    fetchSections(ids)
      .then(function (sections) {
        if (drawerOpen) updateCartPage({ sections: sections });
        else updateDrawerQuietly(sections);
      })
      .catch(function () {});
  }

  /* When this page last showed the basket as the server had it, and a stamp
     every page leaves in sessionStorage whenever the basket changes — read on
     the way back from the page cache, below. ns-card-cart-state.js reads the
     same stamp. */
  var CART_STAMP = 'northsheep_cart_changed';
  var cartSeenAt = Date.now();
  function stampCart() {
    cartSeenAt = Date.now();
    try { sessionStorage.setItem(CART_STAMP, String(cartSeenAt)); } catch (e) {}
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      stampCart();
      // Our own quick-add already updates both copies from its response.
      if (event && event.source === 'ns-cart-upsells') return;
      syncOtherCartCopy();
    });
  }

  /* BACK FROM THE PAGE CACHE, THE BASKET MAY HAVE CHANGED (audit, 23 Sep 2026).

     Safari — and Chrome on an iPhone — hands a page back alive, as it was
     when the shopper left it. Add a hide on its product page, press Back, and
     the basket count in the header still says what it said before, the
     drawer still holds the old basket, and on /cart the page does too: none
     of it re-renders, because nothing on this page ran while it was away.
     So on the way back in, the drawer, the count bubble and (on /cart) the
     page are fetched once and repainted quietly — nothing opens, focus does
     not move — using the same two routines that keep the drawer and the
     /cart page in step above. A page that was reloaded instead never gets
     here: it rendered the current basket already.

     ONLY WHEN THE BASKET ACTUALLY CHANGED while this page was away. A request
     from here can set a session cookie, and ns-card-cart-state.js records
     that a cookie set on page load evicted the page from the back-forward
     cache for good — every later Back then rebuilt it. The stamp says
     whether there is anything to fetch; most returns have nothing to do. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var stamp = 0;
    try { stamp = parseInt(sessionStorage.getItem(CART_STAMP), 10) || 0; } catch (err) {}
    if (stamp <= cartSeenAt) return;
    cartSeenAt = stamp;
    var ids = ['cart-drawer', 'cart-icon-bubble'].concat(
      cartPageSections().map(function (s) {
        return s.sectionId;
      })
    );
    fetchSections(ids)
      .then(function (sections) {
        updateDrawerQuietly(sections);
        updateCartPage({ sections: sections });
      })
      .catch(function () {});
  });

  function addUpsell(variantId, btn) {
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');

    var cartDrawer = document.querySelector('cart-drawer');
    var onCartPage = !!document.getElementById('main-cart-items');
    // Pressed in the drawer or on the page? On /cart both exist, and the one
    // pressed in is the one that must visibly respond.
    var inDrawer = !!(cartDrawer && btn.closest('cart-drawer'));

    var sections = [];
    if (cartDrawer && cartDrawer.getSectionsToRender) {
      sections = cartDrawer.getSectionsToRender().map(function (s) {
        return s.id;
      });
    } else if (cartDrawer) {
      sections = ['cart-drawer', 'cart-icon-bubble'];
    } else {
      sections = ['cart-icon-bubble'];
    }
    // On /cart, the page's own sections too (by their real ids) — one request
    // refreshes both copies. At most 4 of Shopify's 5 allowed.
    if (onCartPage) {
      cartPageSections().forEach(function (s) {
        sections.push(s.sectionId);
      });
    }

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', 1);
    body.append('sections', sections.join(','));
    body.append('sections_url', window.location.pathname);

    var url = (window.routes && routes.cart_add_url) || '/cart/add';
    fetch(url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body,
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (response) {
        if (response.status) {
          // e.g. sold out / exceeds inventory — just release the button.
          btn.classList.remove('is-loading');
          return;
        }
        if (onCartPage) updateCartPage(response);
        if (inDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(response); // updates + keeps the drawer open
        } else if (onCartPage) {
          updateDrawerQuietly(response.sections); // the closed drawer, for later
        } else if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(response);
        } else {
          window.location.reload();
          return;
        }
        window.setTimeout(rankAll, 60);
        announce(variantId);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
      });
  }

  /* SAY THAT THE CART CHANGED.

     This add is a bare fetch, so none of the things Dawn fires on a normal
     add happen here — and everything else in the theme learns about cart
     changes through PUB_SUB_EVENTS.cartUpdate. Without this, adding a
     sheepskin from the cart upsell did not bring its free brush: the gift
     script listens for that event (and for form submits, which this is not)
     and so never heard about the sheepskin at all.

     No cartData is passed on purpose. /cart/add.js answers with the LINE
     ITEM that was added, not the cart, and a listener handed that as a cart
     would read item_count undefined. Listeners fall back to asking the
     server, which is one round trip and always right.

     `source` is our own name, so the subscriber above still skips its own
     echo. */
  function announce(variantId) {
    if (typeof publish !== 'function') return;
    if (typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) return;
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'ns-cart-upsells',
      productVariantId: String(variantId),
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ns-cu-add]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.getAttribute('data-ns-cu-add');
    if (variantId) addUpsell(variantId, btn);
  });

  function init() {
    if ('MutationObserver' in window) {
      observer = new MutationObserver(function () {
        window.clearTimeout(rankAll._t);
        rankAll._t = window.setTimeout(rankAll, 90);
      });
    }
    rankAll();
    bindWheel();
  }

  /* Mouse wheel scrolls the suggestion row sideways.

     A horizontally-overflowing element only responds to HORIZONTAL scroll
     input. A trackpad can emit that with a two-finger sideways swipe, but a
     mouse wheel only ever produces deltaY — so the row looked scrollable and
     did nothing, leaving the scrollbar as the only way to reach the third card.

     Two things this has to get right, both learned the hard way:

     1. DELEGATED, not bound to the row. The cart drawer re-renders its markup
        through the Section Rendering API after every add, change and remove, so
        an element the handler was attached to at init is thrown away. Binding
        directly passed a synthetic test and did nothing in the real drawer.

     2. CAPTURE phase. The drawer is its own scroll container with its own wheel
        handling; a bubbling listener on document is only reached if nothing in
        between consumes the event first.

     Only the visible cards are laid out (the JS hides the rest), so scrollWidth
     already reflects what can actually be reached. */
  function onWheel(e) {
    var row = e.target && e.target.closest ? e.target.closest('[data-ns-cu-row]') : null;
    if (!row) return;

    // A genuine horizontal gesture is already handled by the browser.
    if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;

    var max = row.scrollWidth - row.clientWidth;
    if (max <= 1) return;

    var atStart = row.scrollLeft <= 0;
    var atEnd = row.scrollLeft >= max - 1;
    // At either end, hand the scroll back so the drawer keeps moving.
    if ((e.deltaY < 0 && atStart) || (e.deltaY > 0 && atEnd)) return;

    /* Scroll snapping used to be suspended here and restored when the wheel
       went quiet. Both the suspension and the snapping are gone: restoring it
       is what made the row jump to the next card the moment you stopped, so
       you could never settle mid-strip. See ns-cart-upsells.css.

       A wheel notch is about 100px and a card is 268px wide, so the delta is
       given some travel — otherwise three notches are needed to reveal one
       more suggestion. */
    row.scrollLeft += e.deltaY * 1.6;
    e.preventDefault();
  }

  /* ON THE TWO PLACES THE ROWS LIVE, NOT THE DOCUMENT (audit, 23 Sep 2026).

     A non-passive wheel listener on the document tells the browser that any
     wheel movement anywhere might be cancelled, so every wheel scroll on
     every page had to wait for the main thread before the page could move —
     the "sticky" start of a desktop scroll whenever a script was busy. The
     rows only ever render inside the cart drawer and the /cart page
     (cart-drawer.liquid, main-cart-items.liquid), whose containers survive
     every re-render (reconnect() relies on the same). Capturing on those
     keeps the one property the note above depends on — this runs before the
     drawer's own scroll handling — and leaves the rest of the site's
     scrolling to the compositor. */
  function bindWheel() {
    ['cart-drawer', '#main-cart-items', '#main-cart-footer'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el || el.__nsCuWheelBound) return;
      el.__nsCuWheelBound = true;
      el.addEventListener('wheel', onWheel, { passive: false, capture: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
